// 3rd-party modules
import { Navigate, RouteObject, useRoutes } from 'react-router-dom';

// project modules
import AuthLayout from './layouts/AuthLayout';
import DefaultLayout from './layouts/DefaultLayout';
// import EmptyLayout from './layouts/EmptyLayout';
import IndexPage from './pages/IndexPage';
import LoginWithSMSPage from './pages/auth/LoginWithSMSPage';
import NotFoundPage from './pages/NotFoundPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import DiscountCouponsPage from './pages/DiscountCouponsPage';
import TextExpressPage from './pages/TextExpressPage';
import LoginWithPasswordPage from './pages/auth/LoginPage';
import ReportPage from './pages/ReportPage';

export default function AppRouter() {
  const routes: RouteObject[] = [
    {
      path: 'auth',
      element: <AuthLayout />,
      children: [
        { path: 'login', element: <LoginWithSMSPage /> },
      ]
    },
    {
      path: '/portal',
      element: <DefaultLayout />,
      children: [
        // { path: '', element: <IndexPage /> },
        { path: '', element: <ProtectedRoute><IndexPage /></ProtectedRoute> },
        // { path: 'dashboard', element: <ProtectedRoute><DashboardPage /></ProtectedRoute> },
        { path: 'report', element: <ProtectedRoute><ReportPage /></ProtectedRoute> },
        { path: 'discount-coupon', element: <ProtectedRoute><DiscountCouponsPage /></ProtectedRoute> },
        { path: 'sms-panel', element: <ProtectedRoute><TextExpressPage /></ProtectedRoute> },
      ]
    },
    {
      index: true,
      element: <Navigate to="/portal" replace />
    }
  ];

  if (process.env.NODE_ENV !== 'production') {
    routes.push({
      path: 'auth',
      element: <AuthLayout />,
      children: [
        { path: 'login-old', element: <LoginWithPasswordPage /> }
      ]
    });
    routes.push(
      {
        path: '/temp',
        element: <DefaultLayout />,
        children: [
          { path: '', element: <IndexPage /> },
          { path: 'dashboard', element: <DashboardPage /> },
        ]
      },
    )
  }

  routes.push({
    path: '*',
    element: <NotFoundPage />
  });

  return useRoutes(routes);
}
